var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79094 6.19707C8.77179 6.07392 9.73899 6.46866 10.3593 7.23276C10.4048 7.28885 10.4861 7.30112 10.5444 7.25852C10.8254 7.0532 11.0673 6.79669 11.257 6.50059C12.4391 4.65619 11.1264 2.16669 8.88367 2.16669C7.42019 2.16669 6.21395 3.28824 6.0797 4.71704C6.07428 4.77476 6.10616 4.82987 6.15919 4.8533C6.77141 5.12408 7.29444 5.57022 7.66186 6.13743C7.6897 6.18046 7.7401 6.20343 7.79094 6.19707V6.19707Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88353 1.73333C9.12286 1.73333 9.31686 1.53931 9.31686 1.3V0.433333C9.31686 0.194025 9.12286 0 8.88353 0C8.64419 0 8.4502 0.194025 8.4502 0.433333V1.3C8.4502 1.53931 8.64419 1.73333 8.88353 1.73333Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4333 4.54999H12.5666C12.3273 4.54999 12.1333 4.74401 12.1333 4.98332C12.1333 5.22263 12.3273 5.41665 12.5666 5.41665H13.4333C13.6726 5.41665 13.8666 5.22263 13.8666 4.98332C13.8666 4.74401 13.6726 4.54999 13.4333 4.54999Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7939 7.28145C11.6248 7.11224 11.3504 7.11224 11.1811 7.28145C11.0119 7.4507 11.0119 7.72505 11.1811 7.89427L11.7939 8.50708C11.8785 8.59171 11.9894 8.63402 12.1003 8.63402C12.483 8.63402 12.6805 8.168 12.4067 7.89429L11.7939 7.28145Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97314 2.68524C6.14236 2.85449 6.41671 2.85449 6.58596 2.68524C6.7552 2.516 6.7552 2.24165 6.58596 2.07243L5.97314 1.45962C5.80398 1.2904 5.5296 1.2904 5.36033 1.45962C5.19109 1.62886 5.19109 1.90321 5.36033 2.07243L5.97314 2.68524Z",
    fill: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.488 2.8122C11.5989 2.8122 11.7098 2.76989 11.7944 2.68526L12.4072 2.07244C12.5765 1.9032 12.5765 1.62884 12.4072 1.45963C12.238 1.29041 11.9636 1.29038 11.7944 1.45963L11.1816 2.07247C10.9078 2.34626 11.1054 2.8122 11.488 2.8122V2.8122Z",
    fill: "#757575"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0894 9.42503C10.4234 7.77906 8.69968 6.51004 7.23789 7.26014C6.9166 6.19986 5.93185 5.42798 4.76667 5.42798C3.2545 5.42798 2.06066 6.72308 2.1951 8.24075C0.966821 8.33671 0 9.36376 0 10.6167C0 11.9293 1.06343 13 2.38333 13H10.1292C11.1164 13 11.9167 12.1997 11.9167 11.2125C11.9167 10.269 11.1742 9.42503 10.0894 9.42503Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/Weather.ac6c53fd98c9872a21f136dbc4b890c3.svg";
export { ForwardRef as ReactComponent };